import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs';

import { EndpointFactory } from './endpoint-factory.service';
import { ConfigurationService } from './configuration.service';
import { BusinessRuleMessage } from '../models/BusinessRuleMessage.model';

@Injectable()

export class AnnualCountForecastEndpoint extends EndpointFactory {
  private readonly getDepartmentsEndpointPath: string = "/api/regulatoryItemService/getDepartments";
  private readonly getAllAnnualCountForecastItemsEndpointPath: string = "/api/annualCountForecastItemService/getAllAnnualCountForecastItems";
  private readonly getAnnualCountForecastItemEndpointPath: string = "/api/annualCountForecastItemService/getAnnualCountForecastItem";
  private readonly fileUploadEndpointPath: string = "/api/annualCountForecastItemService/uploadAnnualCountForecastDocument";
  private readonly helpFileUploadEndpointPath: string = "/api/prioritySubmissionService/helpFileUpload";
  private readonly fileDownloadEndpointPath: string = "/api/prioritySubmissionService/downloadFile";
  private readonly helpFileDownloadEndpointPath: string = "/api/prioritySubmissionService/getFileUploadByName";
  private readonly getAnnualCountForecastYearsEndpointPath: string = "/api/ref/getAnnualCountForecastYears";
  private readonly getSessionsEndpointPath: string = "/api/ref/getSessions";
  private readonly submitAnnualCountForecastItemEndpointPath: string = "/api/annualCountForecastItemService/submitAnnualCountForecastItem";
  private readonly getAnnualCountForecastYearsEndpointUrl: string = "/api/ref/getAnnualCountForecastYears";

  get getDepartmentsEndpointUrl() { return this.configurations.baseUrl + this.getDepartmentsEndpointPath; }
  get getAllAnnualCountForecastItemsEndpointUrl() { return this.configurations.baseUrl + this.getAllAnnualCountForecastItemsEndpointPath; }
  get submitAnnualCountForecastItemEndpointUrl() { return this.configurations.baseUrl + this.submitAnnualCountForecastItemEndpointPath; }
  get fileUploadEndpointUrl() { return this.configurations.baseUrl + this.fileUploadEndpointPath; }
  get helpFileUploadEndpointPathEndpointUrl() { return this.configurations.baseUrl + this.helpFileUploadEndpointPath; }
  get fileDownloadEndpointUrl() { return this.configurations.baseUrl + this.fileDownloadEndpointPath; }
  get helpFileDownloadEndpointUrl() { return this.configurations.baseUrl + this.helpFileDownloadEndpointPath; }
  get getAnnualCountForecastItemEndpointUrl() { return this.configurations.baseUrl + this.getAnnualCountForecastItemEndpointPath; }
  get getSessionsEndpointUrl() { return this.configurations.baseUrl + this.getSessionsEndpointPath; }
  get getAnnualCountForecastYearsEndpointPathUrl() { return this.configurations.baseUrl + this.getAnnualCountForecastYearsEndpointPath; }


  constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {
    super(http, configurations, injector);
  }

  getDepartments<T>(userProfileID?: string): Observable<T> {
    let endpointUrl = `${this.getDepartmentsEndpointUrl}/${userProfileID}`;
    return this.http.get<T>(endpointUrl);
  }

  getAnnualCountForecastYears<T>(userProfileID?: string): Observable<T> {
    let endpointUrl = `${this.getAnnualCountForecastYearsEndpointUrl}/${userProfileID}`;
    return this.http.get<T>(endpointUrl);
  }

  getSessions<T>(userProfileID?: string): Observable<T> {
    let endpointUrl = `${this.getSessionsEndpointUrl}/${userProfileID}`;
    return this.http.get<T>(endpointUrl);
  }

  getAllAnnualCountForecastItems<T>(userProfileID?: string): Observable<T> {
    let endpointUrl = `${this.getAllAnnualCountForecastItemsEndpointUrl}/${userProfileID}`;
    return this.http.get<T>(endpointUrl);
  }

  getAllAnnualCountForecastItemsByYear<T>(userProfileID?: string, annualCountForecastYearVldID?: number): Observable<T> {
    let endpointUrl = `${this.getAllAnnualCountForecastItemsEndpointUrl}/${userProfileID}/${annualCountForecastYearVldID}`;
    return this.http.get<T>(endpointUrl);
  }

  getAnnualCountForecastItem<T>(annualCountForecastItemID?: string, userProfileID?: string): Observable<T> {
    let endpointUrl = `${this.getAnnualCountForecastItemEndpointUrl}/${annualCountForecastItemID}/${userProfileID}`;
    return this.http.get<T>(endpointUrl);
  }

  submitAnnualCountForecastItem<T>(userObject: any): Observable<T> {
    let endpointUrl = `${this.submitAnnualCountForecastItemEndpointUrl}/`;
    //console.log(this.http.post<T>(endpointUrl, JSON.stringify(userObject), this.getRequestHeaders()));
    return this.http.post<T>(endpointUrl, JSON.stringify(userObject), this.getRequestHeaders());
  }
  
  async uploadExternalDocument(formData: any) {
    let endpointUrl = `${this.fileUploadEndpointUrl}/`;
    return await this.http.post(endpointUrl, formData, { reportProgress: true, observe: 'events' }).toPromise();
  }

  downloadFile(externalDocumentID: string, fileName: string): Observable<Blob> {
    let endpointUrl = `${this.fileDownloadEndpointUrl}/${externalDocumentID}/${fileName}`;
    return this.http.get(endpointUrl, { responseType: "blob" });
  }
  
}
